var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.categories)?_c('div',_vm._l((_vm.categories_key),function(lang,index){return _c('MerchandisingFieldsDetail',{key:index,attrs:{"lang":lang,"category":_vm.categories[lang]}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }